export const HORIZONTAL_ALIGNS = [
  {
    text: 'Gauche',
    value: 'left',
  },
  {
    text: 'Centre',
    value: 'center',
  },
  {
    text: 'Droit',
    value: 'right',
  },
];

export const VERTICAL_ALIGNS = [
  {
    text: 'Haut',
    value: 'top',
  },
  {
    text: 'Centre',
    value: 'center',
  },
  {
    text: 'Bas',
    value: 'bottom',
  },
];



// WEBPACK FOOTER //
// ./src/shared/constants/resources.js